export const TableCypressAttribute = {
  buttons: {
    DELETE: 'TableCypressAttribute:DELETE',
    EDIT: 'TableCypressAttribute:EDIT',
    APPROVE: 'TableCypressAttribute:APPROVE',
    SEND_EMAIL: 'TableCypressAttribute:SEND_EMAIL',
    VIEW_FINAL_DOCUMENT: 'TableCypressAttribute:VIEW_FINAL_DOCUMENT',
    OPEN_IN_NEW_TAB: 'TableCypressAttribute:OPEN_IN_NEW_TAB',
    VIEW: 'TableCypressAttribute:VIEW',
    VIEW_AND_EDIT: 'TableCypressAttribute:VIEW_AND_EDIT',
    DROPDOWN: 'TableCypressAttribute:DROPDOWN',
    SWITCH: 'TableCypressAttribute:SWITCH',
    DROPDOWN_DELETE: 'TableCypressAttribute:DROPDOWN_DELETE',
    FILTER: 'TableCypressAttribute:FILTER',
    DOWNLOAD: 'TableCypressAttribute:DOWNLOAD',
    NOTE: 'TableCypressAttribute:NOTE',
    DUPLICATE: 'TableCypressAttribute:DUPLICATE',
    RESEND_INVITE: 'TableCypressAttribute:RESEND_INVITE',
    ARCHIVE: 'TableCypressAttribute:ARCHIVE',
    MOVE_DOCUMENT: 'TableCypressAttribute:MOVE_DOCUMENT',
    TOOLTIP: 'TableCypressAttribute:buttons:TOOLTIP',
    RESCHEDULE: 'TableCypressAttribute:buttons:RESCHEDULE',
    CUSTOM_HEADER_SORT_ICON: 'TableCypressAttribute:buttons:CUSTOM_HEADER_SORT_ICON'
  },
  inputs: {
    SEARCH: 'TableCypressAttribute:SEARCH'
  },
  views: {
    ROW: 'TableCypressAttribute:ROW',
    TABLE_ACTION: 'TableCypressAttribute:TABLE_ACTION',
    NOTE_CONTENT: 'TableCypressAttribute:NOTE_CONTENT',
    TOOLTIP: 'TableCypressAttribute:views:TOOLTIP'
  },
  filter: {
    buttons: {
      TRIGGER: 'TableCypressAttribute:FILTER:buttons:TRIGGER',
      ADD_FILTER: 'TableCypressAttribute:FILTER:buttons:ADD_FILTER',
      REMOVE: 'TableCypressAttribute:FILTER:buttons:REMOVE',
      APPLY: 'TableCypressAttribute:FILTER:buttons:APPLY'
    },
    inputs: {
      COLUMNS: 'TableCypressAttribute:filter:inputs:COLUMNS',
      OPERATORS: 'TableCypressAttribute:filter:inputs:OPERATORS',
      VALUE_FORM_SELECT: 'TableCypressAttribute:filter:inputs:VALUE_FORM_SELECT',
      VALUE_DATE_ELEMENT: 'TableCypressAttribute:filter:inputs:VALUE_DATE_ELEMENT',
      SECOND_VALUE_DATE_ELEMENT: 'TableCypressAttribute:filter:inputs:SECOND_VALUE_DATE_ELEMENT',
      VALUE_FORM_ELEMENT: 'TableCypressAttribute:filter:inputs:VALUE_FORM_ELEMENT',
      SECOND_VALUE_FORM_ELEMENT: 'TableCypressAttribute:filter:inputs:SECOND_VALUE_DATE_ELEMENT',
      GROUP_BY_SELECT: 'TableCypressAttribute:filter:inputs:GROUP_BY_SELECT'
    },
    views: {}
  }
};
